import es from './es.json'
import terms from './terms'

const messages = {
  ...es,
  terms,
}

export default messages
